<template>
    <div class="w-full">
      <!-- Cabecera -->
      <div class="bg-white p-4 h-[68px] rounded-lg shadow-md">
        <!-- Estructura original para pantallas grandes -->
        <div class="hidden sm:flex flex-wrap mb-4">
          <div class="flex flex-1 items-center">
            <fwb-heading tag="h2" class="text-style-xl">Asesores</fwb-heading>
          </div>
          <div class="flex flex-1 justify-end items-center">
            <fwb-breadcrumb>
              <fwb-breadcrumb-item href="/advisors" class="custom-alert-text">
                Asesores /
              </fwb-breadcrumb-item>
              <fwb-breadcrumb class="custom-alert-text">
                Edición de Perfil
              </fwb-breadcrumb>
            </fwb-breadcrumb>
          </div>
        </div>

        <!-- Estructura para móviles (se muestra solo en sm y menores) -->
        <div class="sm:hidden flex items-center h-full gap-2">
          <div class="flex-1 min-w-0 overflow-hidden custom-alert-text h-full">
            <fwb-breadcrumb>
              <fwb-breadcrumb-item href="/advisors" class="custom-alert-text">
                Asesores /
              </fwb-breadcrumb-item>
              <fwb-breadcrumb class="custom-alert-text">
                Edición de Perfil
              </fwb-breadcrumb>
            </fwb-breadcrumb>
          </div>
        </div>
      </div>
      
      <!-- Contenedor para la tabla -->
      <div class="mx-auto">
        <div class="flex flex-wrap">
          <!-- inicio de contenido -->
            <div
                class="w-full bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 mt-5 sm:mt-10"      
            >
                <fwb-tabs
                v-model="activeTab"
                class="p-5"
                >
                <fwb-tab
                    name="first"
                    title="Datos generales"
                >
                    <p class="text-sm font-normal leading-6 text-black "> 
                    Por favor, completa todos los campos obligatorios marcados con un asterisco (*). 
                    La información precisa y detallada ayudará a que tu inmueble destaque en el mercado. 
                    </p>
        
                    <FormComponent 
                    :property-id="id" 
                    />        
                </fwb-tab>
        
                <fwb-tab 
                    name="gallery" 
                    title="Galería" 
                    :disabled="!active_tab"
                >
                    <FormGalleryComponent 
                    :property-id="id" 
                    />
                </fwb-tab>
        
                <fwb-tab 
                    name="characters" 
                    title="Características" 
                    :disabled="!active_tab"
                >
                    <FormCharacteristicsComponent 
                    :property-id="id" 
                    section="characteristics"
                    /> 
                </fwb-tab>
        
                <fwb-tab 
                    name="amenities" 
                    title="Amenidades" 
                    :disabled="!active_tab"
                >
                    <FormCharacteristicsComponent 
                    :property-id="id" 
                    section="amenities"
                    /> 
                </fwb-tab>
        
                <fwb-tab 
                    name="friendly" 
                    title="Friendly" 
                    :disabled="!active_tab"
                >
                    <FormCharacteristicsComponent 
                    :property-id="id" 
                    section="friendly"
                    /> 
                </fwb-tab>
        
                <fwb-tab 
                    name="requeriments" 
                    title="Requisitos" 
                    :disabled="!active_tab"
                >
                    <FormCharacteristicsComponent 
                    :property-id="id" 
                    section="requeriments"
                    /> 
                </fwb-tab>
                </fwb-tabs>
            </div>
        </div>
    </div>
      <head>
          <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap" rel="stylesheet">
      </head>
    </div>
  </template>
  <script setup>
  import FormCharacteristicsComponent from "@/components/properties/FormCharacteristicsComponent.vue";
  import FormComponent from "@/components/advisor/PropertiesAdvisorForm.vue";
  import FormGalleryComponent from "@/components/properties/FormGalleryComponent.vue";
  
  import {
    FwbBreadcrumb,
    FwbBreadcrumbItem,
    FwbHeading,
    FwbTab,
    FwbTabs,
  } from "flowbite-vue";
  import { ref, onMounted } from "vue";
  import { useRoute } from "vue-router";
  
  // Acceder al parámetro 'id' de la URL directamente
  const route = useRoute();
  const id = route.params.id;
  let active_tab = ref(false);
  
  const activeTab = ref("first");
  onMounted(async () => {
    console.log(id);
    if (id != undefined) {
      active_tab.value = true;
    }
  });
  </script>